// client/src/services/OrderService.js

import axios from "axios"

export default {
  async getOrders(accessToken) {
	  let res = await axios.get("https://api.test202.co.uk/orders", {
		    headers: {
		      Authorization: `Bearer ${accessToken}`
		    }
		  });
    return res.data;
  },
  async getEventSingle(eventId) {
    let res = await axios.get("http://localhost:8000/events/" + eventId);
    return res.data;
  }
}